import { mapValues } from 'lodash';

import { SET_PERMISSIONS, SetPermissionsPayload } from './actions';
import { defaultPermissionsState, PermissionsState } from './store';
import { CaseReducer, createReducer } from '@reduxjs/toolkit';

type Re<P = unknown> = CaseReducer<
  PermissionsState,
  { payload: P; type: string }
>;

const onActionSetPermissions: Re<SetPermissionsPayload> = (
  state,
  { payload }
) => ({
  ...state,
  ...mapValues(payload, (v, k: keyof PermissionsState) =>
    v && state[k][1] <= v[1] ? v : state[k]
  ),
});

export default createReducer(defaultPermissionsState, (builder) => {
  builder.addCase(SET_PERMISSIONS, onActionSetPermissions);
});
